/**
 * Common functionality for Room and Table messages
 */
import ChatMessage from "@/components/DigitalEvent/RoomList/Room/Chat/components/ChatMessage";

const DEFAULT_MESSAGES_BREAKPOINT = 30;

export default {
  components: {
    "chat-message": ChatMessage
  },
  data() {
    return {
      message: "",
      loadMoreClicks: 0
    };
  },
  computed: {
    /**
     * Current user
     * @return {Object}
     */
    user() {
      return this.$store.state.users.user;
    },

    /**
     * Current chat mode (TABLE, PRIVATE)
     * @return {String}
     */
    chatMode() {
      return this.$store.state.chat.chatMode;
    },

    canSendMessage() {
      return this.message.trim();
    },

    messagesBreakpoint() {
      return this.$store.state.event.config.defaultTextChatConfig &&
        this.$store.state.event.config.defaultTextChatConfig.messagesBreakpoint
        ? this.$store.state.event.config.defaultTextChatConfig.messagesBreakpoint
        : DEFAULT_MESSAGES_BREAKPOINT;
    },
    messagesToShow() {
      return (this.loadMoreClicks + 1) * this.messagesBreakpoint;
    },
    exposedMessages() {
      return this.messages.slice(Math.max(this.messages.length - this.messagesToShow, 0));
    },
    canLoadMoreMessages() {
      return this.messages.length > this.exposedMessages.length;
    }
  },
  methods: {
    /**
     * Check that message is mine
     * @param message {Object}
     * @return {boolean}
     */
    isMine(message) {
      return message.userUUID && message.userUUID === this.user.user_uuid;
    },

    loadMoreMessages() {
      this.loadMoreClicks += 1;
    },
    emojiPicked(emoji) {
      this.message = this.message + " " + emoji;
    },
    sendPrivateMessage(user, scrollPage = false) {
      this.$store.commit("chat/setPrivateChatTarget", {
        userUUID: user.userUUID,
        firstName: user.firstName,
        lastName: user.lastName,
        domain: user.domain
      });
      this.openTabs(["#tab-chat", "#tab-chat-private"], scrollPage);
      this.$store.commit("chat/changeChatMode", { mode: "PRIVATE", scrollPage });
    },
    openTabs(tabNames, doScroll) {
      tabNames.forEach((tab, index) => {
        setTimeout(() => {
          this.$root.$emit("activateTab", tab);
        }, 300 * index);
      });

      if (doScroll) {
        this.$scrollTo("#people-chat-container");
      }
    }
  }
};
